import { Directive, OnInit } from '@angular/core';
import { MatCalendarCellCssClasses, MatDatepicker } from '@angular/material/datepicker';
import { Utils } from '../utils.class';

@Directive({
    selector: 'mat-datepicker:not([noWeekNumbers])',
    standalone: true,
})
export class DatepickerWeekNumberDirective implements OnInit {
    constructor(private datepicker: MatDatepicker<Date>) {}

    ngOnInit(): void {
        this.datepicker.panelClass = [...(this.datepicker.panelClass ?? []), 'with-weeknumbers'].filter(x => !!x);
        if (!this.datepicker.dateClass) {
            this.datepicker.dateClass = (date: Date): MatCalendarCellCssClasses => {
                if (date.getDay() === 1) {
                    return `monday-week-${Utils.getWeek(date)}`;
                }
                return '';
            };
        }
    }
}
